var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2368_42904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.427 22.4825H13.4146L15.2988 10.314H18.311L16.427 22.4825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3476 10.6118C26.7534 10.3656 25.8109 10.0938 24.6456 10.0938C21.6707 10.0938 19.5758 11.7507 19.563 14.1195C19.5383 15.8673 21.0629 16.838 22.2032 17.4208C23.3686 18.0162 23.7648 18.4049 23.7648 18.9357C23.7529 19.7509 22.823 20.1267 21.9557 20.1267C20.753 20.1267 20.1086 19.933 19.1293 19.4794L18.7326 19.285L18.311 22.0166C19.0176 22.3528 20.3193 22.6511 21.6707 22.6642C24.8316 22.6642 26.8894 21.0329 26.9138 18.5085C26.9258 17.1233 26.1208 16.0619 24.3852 15.1945C23.3316 14.6378 22.6863 14.2623 22.6863 13.6926C22.6987 13.1748 23.2321 12.6443 24.4214 12.6443C25.4008 12.6183 26.1203 12.8642 26.6654 13.1102L26.9379 13.2395L27.3476 10.6118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3512 18.1716C31.5993 17.4725 32.5539 14.767 32.5539 14.767C32.5414 14.7929 32.8015 14.055 32.9502 13.602L33.1608 14.6505C33.1608 14.6505 33.7312 17.5632 33.8551 18.1716C33.3843 18.1716 31.9462 18.1716 31.3512 18.1716ZM35.0697 10.314H32.7395C32.021 10.314 31.4751 10.5339 31.165 11.3236L26.6904 22.4823H29.8513C29.8513 22.4823 30.3717 20.9804 30.4835 20.657C30.8303 20.657 33.9052 20.657 34.3513 20.657C34.4378 21.0842 34.7107 22.4823 34.7107 22.4823H37.5L35.0697 10.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 10.314L7.94823 18.6117L7.62585 16.9288C7.08042 14.987 5.36985 12.8773 3.46094 11.8282L6.16319 22.4696H9.34878L14.0838 10.314H10.8984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20882 10.314H0.362084L0.3125 10.5598C4.09326 11.5696 6.59718 14.0037 7.62593 16.9294L6.5723 11.3368C6.39884 10.5597 5.86577 10.3396 5.20882 10.314Z",
    fill: "#A8ACB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2368_42904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.1875,
    height: 12.5704,
    fill: "white",
    transform: "translate(0.3125 10.0938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.c1565802d036b8308a49fa85bb4f28ff.svg";
export { ForwardRef as ReactComponent };